module.exports = __webpack_public_path__ + "img/summarize.4bf562bc.jpg";